import React, { useEffect, useState } from "react";
import "./message.css";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Grid,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  MenuItem,
  Skeleton,
  Menu,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import StyledTableCell from "../../Tabletheme/Customtableheader";
import BackDropLoaderApi from "../../Allloader/BackDropLoaderApi";
import MessageTypesDrawer from "./MessageTypesDrawer";
import Swal from "sweetalert2";

const MessageTypes = () => {
  const [sortObj, setSortObj] = useState({
    name: "message_type_name",
    order: "asc",
  });
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [backDrop, setBackDrop] = useState(false);
  const [loader, setLoader] = useState(true);
  const [drawerCaller, setDrawerCaller] = useState({
    name: "",
    data: "",
  });
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [endPointTableData, setEndpointTableData] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [mappingstream, setMappingStream] = useState([]);
  const [dropdownvisble, setDropdownvisble] = useState("");

  const handleButtonClick = () => {
    setIsDrawerOpen(true);
  };
  const handleClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowIndex(index);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRowIndex(null);
  };
  const deleteRow = (id) => {
    setBackDrop(true);
    try {
      instance
        .delete(`api/v1/Master/MessageType/Delete/${id}`)
        .then((res) => {
          if (res?.data?.Success) {
            setEndpointTableData((prevData) => {
              return prevData.filter(row => row.message_type_id !== id);
            });
             getMessageType();
            setBackDrop(false);
            Swal.fire({
              icon: "success",
              title: "Deleted!",
              text: res?.data?.ResultMessage,
              customClass: {
                confirmButton: "custom-confirm-button-class",
              },
              buttonsStyling: false,
              showCancelButton: false,
              confirmButtonText: "OK",
              allowOutsideClick: false,
            });
          } else {
            setBackDrop(false);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: res?.data?.ResultMessage,
              customClass: {
                confirmButton: "custom-cancle-button-class",
              },
              buttonsStyling: false,
              showCancelButton: false,
              confirmButtonText: "OK",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          setBackDrop(false);
        })
        .finally(() => {
          setBackDrop(false);
        });
    } catch (err) {
      console.log(err);
      setBackDrop(false);
    }
  };
  const getMessageType = (pageNumber = pageNo, searchinfo = searchValue) => {
    const body = {
      id: "",
      searchtext: searchinfo,
      pageno: pageNumber,
      pagesize: 10,
      sortby: sortObj.name,
      sortord: sortObj.order,
    };
    instance
      .post("api/v1/Master/MessageType/Get", body)
      .then((res) => {
        if (res?.data?.Success) {
          setTotalRecods(res?.data?.Records ?? 0);
          if (pageNumber == 1) {
            setEndpointTableData(() => {
              return [...(res?.data?.Value ?? [])];
            });
          } else {
            setEndpointTableData((prev) => {
              return [...prev, ...(res?.data?.Value ?? [])];
            });
          }
        } else {
          setTotalRecods(0);
          setEndpointTableData((prevData) => {
            return [...prevData];
          });
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const getMappingStream = () => {
    const body = {
      id: "",
      searchtext: dropdownvisble,
    
    };
    instance
      .post("api/v1/Master/MappingStream/Get", body)
      .then((res) => {
        if (res?.data?.Success) {
          setMappingStream((prev) => {
              return [...prev, ...(res?.data?.Value ?? {})];
        })
      } 
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  useEffect(() => {
    getMessageType();
  }, [sortObj]);

  return (
    <>
      <div className="parentMessage_div">
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="mb-4"
        >
          <p className="headingMessage_font">Message Types</p>
          <p className="Messagehead_div"></p>
        </div>
        {backDrop && <BackDropLoaderApi open={backDrop} />}
        {isDrawerOpen && (
          <MessageTypesDrawer
            getMessageType={getMessageType}
            setIsDrawerOpen={setIsDrawerOpen}
            isDrawerOpen={isDrawerOpen}
            drawerCaller={drawerCaller}
            setBackDrop={setBackDrop}
            getMappingStream={getMappingStream}
            mappingstream={mappingstream}
            setMappingStream={setMappingStream}
            dropdownvisble={dropdownvisble}
            setDropdownvisble={setDropdownvisble}
          />
        )}
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xl={2} lg={2.6} md={6} sm={12} xs={12}>
            <Button
              variant="contained"
              className="button_headermessage"
              onClick={() => {
                handleButtonClick();
                setDrawerCaller({
                  name: "Add",
                  data: "",
                });
              }}
              color="secondary"
              sx={{
                width: "100%",
              }}
            >
              Add Message Type <AddIcon />
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div className="search-sectionmessage d-flex">
              <div>
                <img src="assets/Images/searchicon.svg" alt="Search Icon" />
              </div>
              <div className="search-inputmessage">
                <input
                  onKeyUp={(event) => {
                    if (event.key === "Enter") {
                      getMessageType(1, event.target.value);
                    }
                  }}
                  onChange={(event) => {
                    setSearchValue(event.target.value);
                    if (event.target.value.length === 0) {
                      getMessageType(1, "");
                    }
                  }}
                  type="text"
                  placeholder="Search / Filter"
                />
              </div>
            </div>
          </Grid>
        </Grid>

        <TableContainer sx={{ marginTop: 5, maxHeight: 600 }} component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow className="Table_row">
                <StyledTableCell>
                  Type Name{" "}
                  {sortObj?.order == "asc" ? (
                    <img
                      onClick={() => {
                        setSortObj((prev) => {
                          return {
                            ...prev,
                            order: "desc",
                          };
                        });
                      }}
                      src="assets/Images/Ascending.svg"
                      alt="Ascending"
                      style={{ width: "13px", marginLeft: "5px" }}
                    />
                  ) : (
                    <img
                      onClick={() => {
                        setSortObj((prev) => {
                          return {
                            ...prev,
                            order: "asc",
                          };
                        });
                      }}
                      src="assets/Images/descending.svg"
                      alt="Descending"
                      style={{ width: "13px", marginLeft: "5px" }}
                    />
                  )}
                </StyledTableCell>
                <StyledTableCell>Success Alert</StyledTableCell>
                <StyledTableCell>Failure Alert</StyledTableCell>
                <StyledTableCell>Is EDIFact Inbound?</StyledTableCell>
                <StyledTableCell>Filename Pattern</StyledTableCell>
                <StyledTableCell>Contents Pattern</StyledTableCell>
                <StyledTableCell>Latency Type</StyledTableCell>
                <StyledTableCell>Mapping Stream</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            {loader ? (
              <>
                {new Array(5).fill(3).map((element, index) => {
                  return (
                    <TableRow key={index}>
                      {new Array(9).fill(1).map((element, index) => {
                        return (
                          <TableCell align="center" key={index}>
                            <Skeleton
                              variant="rounded"
                              width={"100%"}
                              height={60}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <>
                {endPointTableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <p>No Data Found</p>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody>
                    {endPointTableData.map((singleRowInformation, index) => (
                      <TableRow key={index}>
                        {/* key={singleRowInformation?.message_type_id} */}
                        <TableCell>
                          {singleRowInformation?.message_type_name}
                        </TableCell>
                        <TableCell>
                          {singleRowInformation?.success_alert_type}
                        </TableCell>
                        <TableCell>
                          {singleRowInformation?.failure_alert_type}
                        </TableCell>
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="secondary"
                            checked={
                              singleRowInformation?.message_type_is_edifact_inbound ==
                              1
                                ? true
                                : false
                            }
                          />
                        </TableCell>
                        <TableCell>
                          {singleRowInformation?.filename_pattern_01}
                        </TableCell>
                        <TableCell>
                          {singleRowInformation?.contents_pattern_01}
                        </TableCell>
                        <TableCell>
                          {singleRowInformation?.latency_type}
                        </TableCell>
                        <TableCell>
                          {singleRowInformation?.mapping_stream}
                        </TableCell>
                        <TableCell>
                          <div style={{ textAlign: "center" }}>
                            <Button
                              id="basic-button"
                              aria-controls={
                                Boolean(anchorEl)
                                  ? `basic-menu-${index}`
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                Boolean(anchorEl) ? "true" : undefined
                              }
                              onClick={(event) => {
                                handleClick(event, index);
                              }}
                            >
                              <MoreVertIcon />
                            </Button>
                            <Menu
                              id={`basic-menu-${index}`}
                              anchorEl={anchorEl}
                              open={
                                selectedRowIndex !== null &&
                                selectedRowIndex === index
                              }
                              onClose={handleClose}
                              MenuListProps={{
                                "aria-labelledby": `basic-button-${index}`, 
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  getMappingStream();
                                  handleClose();
                                  handleButtonClick();
                                  setDrawerCaller({
                                    name: "edit",
                                    data: singleRowInformation,
                                  });
                                }}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleClose();
                                  Swal.fire({
                                    icon: "question",
                                    text: "Are you sure you want to delete",
                                  
                                    customClass: {
                                      confirmButton:
                                        "custom-confirm-button-class",
                                      cancelButton:
                                        "custom-cancle-button-class",
                                    },
                                    buttonsStyling: false,
                                    showCancelButton: true,
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Cancel",
                                    allowOutsideClick: false,
                                    reverseButtons: true, 
                                  }).then((responce) => {
                                    if (responce?.isConfirmed) {
                                      deleteRow(
                                        singleRowInformation?.message_type_id
                                      );
                                    } else {
                                    }
                                  });
                                }}
                              >
                                Delete
                              </MenuItem>
                            </Menu>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        <Grid item xs={12} className="mt-4" sx={{ textAlign: "center" }}>
          {endPointTableData.length > 0 &&
            totalRecods > endPointTableData.length && (
              <Button
                id="back-button"
                variant="contained"
                color="secondary"
                sx={{ textTransform: "none" }}
                onClick={() => {
                  setShowmoreLoader(true);
                  setPageNo((prev) => prev + 1);
                  getMessageType(pageNo + 1,searchValue,sortObj);
                }}
              >
                {showmoreLoader ? "loading" : "Show More"}
              </Button>
            )}
        </Grid>
      </div>
    </>
  );
};

export default MessageTypes;
